import { create } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware' // Import persist

import { type UserSlice, createUserSlice } from './userSlice'

type AppState = UserSlice

export const useAppStore = create<AppState>()(
  devtools(
    persist(
      (...a) => ({
        ...createUserSlice(...a)
      }),
      {
        name: 'app-store',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
          user: state.user,
          isLoggedIn: state.isLoggedIn,
          warehouseId: state.warehouseId
        }),

        onRehydrateStorage: () => (state) => {
          state?.setHasHydrated(true)
        }
      }
    ),
    { name: 'AppStore' }
  )
)
